/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const childRoutes = [];

// Permit Venue Details
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId',
    exact: true,
    componentName: 'PermitVenuePage',
    title: 'Permit Venue Details',
};

// Detailed Availability
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/registration/detailed-availability',
    componentName: 'DetailedAvailabilityConductor',
    title: 'Detailed Availability',
};

// Order Details
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/registration/:reservationId',
    componentName: 'PermitRegistrationPage',
    title: 'Order Details',
};

// Lottery Registration
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/lottery/:lotteryId/registration/:reservationId',
    componentName: 'LotteryRegistrationPage',
    title: 'Lottery Registration',
};

// Lottery Winner Confirmation
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/lotteries/awarded',
    exact: true,
    componentName: 'LotteryWinnerConfirmationPage',
    title: 'Lottery Winner Confirmation',
};

// Alternate Permit Holder Confirmation
childRoutes[childRoutes.length] = {
    path: '/permits/registration/:reservationId/alternate',
    componentName: 'AlternatePermitHolderConfirmationPage',
    title: 'Alternate Permit Holder Confirmation',
};

// Tertiary Content
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/additional-information',
    componentName: 'TertiaryContentPage',
    title: 'Additional Information',
};

// Order Confirmation
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/confirmation',
    componentName: 'CartlessConfirmationPage',
    title: 'Order Confirmation',
};

// Lottery Schedule
childRoutes[childRoutes.length] = {
    path: '/permits/:permitId/lotteryschedule',
    componentName: 'LotterySchedulePage',
    title: 'Lottery Schedule',
};

// Lottery Schedule
childRoutes[childRoutes.length] = {
    path: '/permits/mobile/redirector',
    componentName: 'MobileRedirector',
    title: 'Lottery Redirector',
};

export default childRoutes;
